<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="data"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 100"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">
              客户端组织机构权限范围
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="
                openEditFormDialog({
                  type: 'add',
                })
              "
              v-if="!disabled && clientCode"
              ><i class="el-icon-plus" />新增
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{row}">
        <el-tooltip class="item" effect="dark" content="编辑" placement="top">
          <i
            class="el-icon-edit tool-btn"
            @click="
              openEditFormDialog({
                type: 'edit',
                code: row.clientOrgScopeCode,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="删除" placement="top">
          <i
            class="el-icon-delete tool-btn"
            @click="del(row.clientOrgScopeCode)"
          ></i>
        </el-tooltip>
      </template>
    </vxe-grid>

    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="800px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      v-el-dialog-drag
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :clientOrgScopeCode="editFormDialogOptions.code"
        :clientCode="clientCode"
        @reload="getData"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">
          取消
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditForm from './edit-form'
export default {
  mixins: [TableAutoHeight],
  components: {EditForm},
  props: {
    disabled: {type: Boolean, default: false},
    clientCode: {type: String, default: ''},
  },
  data() {
    return {
      data: [],
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.getData(),
        },
      },

      tableColumns: tableColumns(this),

      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.clientCode) return
      this.loading = true
      this.$api
        .sysOpenapiClientOrgScopeListApi({
          clientCode: this.clientCode,
        })
        .then((res) => {
          this.loading = false
          this.data = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({type, code = ''}) {
      const types = {
        edit: '编辑客户端组织机构权限范围',
        add: '新增客户端组织机构权限范围',
        detail: '客户端组织机构权限范围详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
    del(code) {
      this.$confirm('确认要删除该记录吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.$api
          .sysOpenapiClientOrgScopeDelApi({
            clientOrgScopeCode: code,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.getData()
          })
      })
    },
  },
}
</script>